import React from 'react';

/**
 * Renderiza el bloque SimpleChart de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function SimpleChart({
  v
}) {
  return React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "minmax(0,1fr) 22.916667vw",
      "gap": "1.111111vh",
      "minHeight": "0"
    }
  }, v.text("\n      "), React.createElement("section", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "1.296296vh 1.481481vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.740741vh",
      "minHeight": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "1.111111vh",
      "flexWrap": "wrap"
    }
  }, React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.388889vh",
      "fontWeight": "600"
    }
  }, v.text("Jaulas · requiere atención primero")), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, v.text(v.smWinLab)), React.createElement("div", {
    style: {
      "marginLeft": "auto",
      "display": "flex",
      "gap": "1.296296vh",
      "fontSize": "1.018519vh",
      "color": "#8793a6"
    }
  }, React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "1.111111vh",
      "borderRadius": "0.277778vh",
      "background": "oklch(0.58 0.19 25 / 0.5)"
    }
  }, null), v.text("Crítico")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "1.111111vh",
      "borderRadius": "0.277778vh",
      "background": "oklch(0.75 0.15 75 / 0.3)"
    }
  }, null), v.text("Atención")), React.createElement("span", {
    style: {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.462963vh"
    }
  }, React.createElement("span", {
    style: {
      "width": "0.625vw",
      "height": "1.111111vh",
      "borderRadius": "0.277778vh",
      "background": "rgba(46,179,238,0.08)"
    }
  }, null), v.text("Normal")), React.createElement("span", {
    style: {
      "color": "#5a667a"
    }
  }, v.text("· vs meta (SFR 100 %) o promedio de jaulas")))), v.text("\n        "), React.createElement("div", {
    style: {
      "display": "grid",
      "gridTemplateColumns": "1.875vw 4.791667vw 2.916667vw repeat(6,minmax(0,1fr))",
      "gap": "0.37037vh",
      "padding": "0 0.37037vh",
      "font": "600 1.018519vh 'IBM Plex Sans',sans-serif",
      "color": "#8793a6"
    }
  }, React.createElement("span", {}, v.text("#")), React.createElement("span", {}, v.text("Jaula")), React.createElement("span", {
    "title": "Puntaje: crítico = 3, atención = 1"
  }, v.text("Atención")), (v.smCols || []).map((h, index101) => React.createElement(React.Fragment, {
    key: index101
  }, React.createElement("span", {
    style: {
      "textAlign": "center",
      "whiteSpace": "nowrap",
      "overflow": "hidden",
      "textOverflow": "ellipsis"
    }
  }, v.text(h.l))))), v.text("\n        "), React.createElement("div", {
    "onMouseLeave": v.smCellLeave,
    style: {
      "flex": "1",
      "minHeight": "0",
      "position": "relative",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.277778vh"
    }
  }, v.text("\n          "), (v.smRows || []).map((row, index102) => React.createElement(React.Fragment, {
    key: index102
  }, React.createElement("div", {
    "onClick": row.go,
    "title": "Abrir en General",
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateColumns": "1.875vw 4.791667vw 2.916667vw repeat(6,minmax(0,1fr))",
      "gap": "0.37037vh",
      "alignItems": "stretch",
      "padding": "0 0.37037vh",
      "borderRadius": "0.462963vh",
      "cursor": "pointer",
      "background": row.rowBg
    }
  }, React.createElement("span", {
    style: {
      "alignSelf": "center",
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#5a667a"
    }
  }, v.text(row.n)), React.createElement("span", {
    style: {
      "alignSelf": "center",
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "color": row.nameC,
      "whiteSpace": "nowrap"
    }
  }, v.text(row.name)), React.createElement("span", {
    style: {
      "alignSelf": "center",
      "justifySelf": "start",
      "minWidth": "1.458333vw",
      "textAlign": "center",
      "padding": "0.185185vh 0.740741vh",
      "borderRadius": "0.925926vh",
      "font": "600 1.111111vh 'IBM Plex Mono',monospace",
      "background": row.attBg,
      "color": row.attC
    }
  }, v.text(row.att)), (row.cells || []).map((c, index103) => React.createElement(React.Fragment, {
    key: index103
  }, React.createElement("div", {
    "onMouseEnter": c.enter,
    style: {
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "borderRadius": "0.37037vh",
      "background": c.bg,
      "outline": c.ol,
      "font": c.fw + " 1.203704vh 'IBM Plex Mono',monospace",
      "color": c.c,
      "whiteSpace": "nowrap",
      "minWidth": "0"
    }
  }, v.text(c.v))))))), v.text("\n          "), v.smTip.on ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "position": "absolute",
      "left": v.smTip.left,
      "top": v.smTip.top,
      "transform": v.smTip.tx,
      "zIndex": "30",
      "width": "11.979167vw",
      "background": "rgba(6,14,28,0.96)",
      "border": "0.092593vh solid rgba(46,179,238,0.35)",
      "borderRadius": "0.740741vh",
      "padding": "0.925926vh 1.111111vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "pointerEvents": "none",
      "boxShadow": "0 0.925926vh 2.592593vh rgba(0,0,0,0.5)"
    }
  }, React.createElement("span", {
    style: {
      "fontWeight": "600",
      "fontSize": "1.203704vh"
    }
  }, v.text(v.smTip.title)), React.createElement("div", {
    style: {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "baseline",
      "gap": "0.740741vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "600 1.666667vh 'IBM Plex Mono',monospace"
    }
  }, v.text(v.smTip.v)), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6",
      "textAlign": "right"
    }
  }, v.text(v.smTip.vl))), React.createElement("svg", {
    "viewBox": "0 0 140 40",
    "preserveAspectRatio": "none",
    style: {
      "width": "100%",
      "height": "3.703704vh",
      "display": "block"
    }
  }, React.createElement("path", {
    "d": v.smTip.bars,
    "fill": "oklch(0.74 0.12 230)"
  }, null), React.createElement("path", {
    "d": v.smTip.ref,
    "stroke": "oklch(0.7 0.17 45)",
    "strokeDasharray": "3 3",
    "fill": "none",
    "vectorEffect": "non-scaling-stroke"
  }, null)), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#8793a6"
    }
  }, v.text(v.smTip.sub)), React.createElement("span", {
    style: {
      "fontSize": "1.018519vh",
      "color": "#5a667a"
    }
  }, v.text(v.smTip.avg)))) : null, v.text("\n        ")), v.text("\n      ")), v.text("\n      "), React.createElement("aside", {
    style: {
      "background": "linear-gradient(180deg,rgba(22,40,64,0.55) 0%,rgba(12,24,42,0.55) 100%)",
      "border": "0.092593vh solid rgba(46,179,238,0.14)",
      "borderRadius": "0.925926vh",
      "boxShadow": "0 0.092593vh 0 rgba(255,255,255,0.03) inset,0 0.740741vh 2.222222vh rgba(0,0,0,0.25)",
      "padding": "1.296296vh 1.481481vh",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.925926vh",
      "minHeight": "0"
    }
  }, v.text("\n        "), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh"
    }
  }, React.createElement("h2", {
    style: {
      "margin": "0",
      "fontSize": "1.388889vh",
      "fontWeight": "600"
    }
  }, v.text("Requiere atención")), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#8793a6"
    }
  }, v.text(v.smAlertN))), v.text("\n        "), v.smNoAlerts ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "fontSize": "1.203704vh",
      "color": "oklch(0.78 0.14 155)",
      "padding": "1.111111vh 0"
    }
  }, v.text("Sin avisos para los últimos 7 días"))) : null, v.text("\n        "), React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "overflow": "auto",
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.555556vh",
      "paddingRight": "0.208333vw"
    }
  }, (v.smAlerts || []).map((a, index104) => React.createElement(React.Fragment, {
    key: index104
  }, React.createElement("div", {
    "onClick": a.go,
    "title": "Abrir jaula y día en General",
    style: {
      "display": "grid",
      "gridTemplateColumns": "0.15625vw minmax(0,1fr) auto",
      "gap": "0.925926vh",
      "alignItems": "center",
      "padding": "0.740741vh 0.925926vh 0.740741vh 0",
      "borderRadius": "0.555556vh",
      "background": "rgba(3,10,22,0.45)",
      "cursor": "pointer",
      "flex": "none"
    },
    className: "scapp-full-hover"
  }, React.createElement("span", {
    style: {
      "alignSelf": "stretch",
      "borderRadius": "0 0.185185vh 0.185185vh 0",
      "background": a.bar
    }
  }, null), React.createElement("div", {
    style: {
      "display": "flex",
      "flexDirection": "column",
      "gap": "0.185185vh",
      "minWidth": "0"
    }
  }, React.createElement("div", {
    style: {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "0.740741vh"
    }
  }, React.createElement("span", {
    style: {
      "font": "600 1.203704vh 'IBM Plex Mono',monospace",
      "color": "#e4e9f0"
    }
  }, v.text(a.name)), React.createElement("span", {
    style: {
      "fontSize": "0.925926vh",
      "fontWeight": "600",
      "letterSpacing": "0.05em",
      "textTransform": "uppercase",
      "color": a.lvlC
    }
  }, v.text(a.lvl))), React.createElement("span", {
    style: {
      "fontSize": "1.111111vh",
      "color": "#b8c1ce",
      "textWrap": "pretty"
    }
  }, v.text(a.txt))), React.createElement("span", {
    style: {
      "font": "1.018519vh 'IBM Plex Mono',monospace",
      "color": "#8793a6",
      "whiteSpace": "nowrap"
    }
  }, v.text(a.day + " ›")))))), v.text("\n      ")), v.text("\n    "));
}
